module.exports = __webpack_public_path__ + "c2b2d72751fc5a459a8cd3dbbed2f171.svg";